module.exports = __webpack_public_path__ + "assets/img/new_ground.png?e8af1fa26ee28f988e099ee1d0107396";